export const mediaItems = [
  // Live photos
  {
    id: 'live-1',
    image: '/images/live/1.jpg',
    credit: 'photograph by Stig Buvarp',
    type: 'image'
  },
  {
    id: 'live-2', 
    image: '/images/live/2.JPG',
    credit: 'photograph by Karina Krokaa',
    type: 'image'
  },
  {
    id: 'live-3',
    image: '/images/live/3.jpg', 
    credit: 'photograph by Enneke Hempen',
    type: 'image'
  },
  {
    id: 'live-4',
    image: '/images/live/4.JPG',
    credit: 'photograph by Tara Tjemsland Lillebø',
    type: 'image'
  },
  // Portrait photos
  {
    id: 'portrait-1',
    image: '/images/portrait/1.jpg',
    credit: 'photograph by Heidi Henriksen',
    type: 'image'
  },
  {
    id: 'portrait-2',
    image: '/images/portrait/2.jpg',
    credit: 'photograph by Ingvild Ness',
    type: 'image'
  },
  {
    id: 'portrait-3',
    image: '/images/portrait/3.jpg',
    credit: 'photograph by Ingvild Ness',
    type: 'image'
  },
  // Studio photos
  {
    id: 'studio-1',
    image: '/images/studio recording/imm013_11A.jpg',
    type: 'image'
  },
  {
    id: 'studio-2',
    image: '/images/studio recording/imm014_12A.jpg',
    type: 'image'
  },
  {
    id: 'studio-3',
    image: '/images/studio recording/imm020_18A.jpg',
    type: 'image'
  },
  {
    id: 'studio-4',
    image: '/images/studio recording/imm021_19A.jpg',
    type: 'image'
  },
  {
    id: 'studio-5',
    image: '/images/studio recording/imm022_20A.jpg',
    type: 'image'
  },
  {
    id: 'studio-6',
    image: '/images/studio recording/imm023_21A.jpg',
    type: 'image'
  },
  {
    id: 'studio-7',
    image: '/images/studio recording/imm024_22A.jpg',
    type: 'image'
  },
  {
    id: 'studio-8',
    image: '/images/studio recording/imm025_23A.jpg',
    type: 'image'
  },
  // Music video
  {
    id: 'music-video-1',
    image: '/images/music video/1.png',
    title: '"You Don\'t Hear It (Do You?)" Official Music Video',
    description: 'Nominated for best music video at Grimstad Short Film Festival 2025',
    url: 'https://youtu.be/Ut2DUWazSfI?si=WBlKQX5-C-am_Sos',
    type: 'video'
  }
];
